import React from 'react';
import { Layout } from 'src/Layout';
import { person } from 'src/config';
import { ContactHero, MyClients } from 'src/section';

const UnmemoContact: React.FC = () => (
  <Layout
    title={`Contact - ${person.name}`}
    description="I&#039;m Isha Hasan, Front-end Developer based in Karachi, Pakistan. I created many projects over the years. I focus on code quality and best practices."
    keywords="front-end developer, react developer, web developer, freelance developer"
  >
    <ContactHero />
    {/* <ContactForm /> */}
    <MyClients />
  </Layout>
);

export const Contact = React.memo(UnmemoContact);
